import { store } from 'src/redux/store';
import utils from 'utils';

export default {
  getContactMessenger(data) {
    return this.http(
      'APPInterface',
      'get',
      'v1/feedback/messages',
      data
    );
  },
  postContactMessenger(data) {
    let appKey = data.category;
    if (appKey === 'mini_yys') {
      appKey = 'nutrition';
    }

    const queryParmas = utils.getQueryString() || {};
    const { token } = store.getState();
    const headers = {
      token: token,
      'App-Key': appKey,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'App-Device': queryParmas.app_device || '',
      'App-Version': queryParmas.app_version || '',
      'Os-Version': queryParmas.os_version || ''
    };

    return this.http(
      'APPInterface',
      'post',
      'v1/feedback/send_message',
      data,
      headers
    );
  }
};
